import { render, staticRenderFns } from "./AboutHeb.vue?vue&type=template&id=a3594384&scoped=true&"
import script from "./AboutHeb.vue?vue&type=script&lang=js&"
export * from "./AboutHeb.vue?vue&type=script&lang=js&"
import style0 from "./AboutHeb.vue?vue&type=style&index=0&id=a3594384&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3594384",
  null
  
)

export default component.exports